import { apiSlice } from "./apiSlice";

export const leaseDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => {
        return {

            getLeaseData: builder.query({
                query: ({ projectId }) => ({
                    url: "/LeaseDashboard/kpi",
                    method: "GET",
                    params: { projectId },
                }),
            })
        };
    },
});

export const {
    useGetLeaseDataQuery,
} = leaseDashboardSlice;
